import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '@Environments/environment';
import { GeneralApiEndpoints } from '@AppCore/constants/api-endpoints';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { HttpHelperService } from '@AppCore/services/http-helper.service';

import { Address, UserProfile } from '@AppRoot/shared/models/user.interface';
import { Observable, of } from 'rxjs';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';
@Injectable({
  providedIn: 'root',
})
export class ShoppingService {
  constructor(
    private http: HttpHelperService,
    private globalUtilityService: GlobalUtilityService,
    private sharedService: SharedService
  ) {}

  setRazorPayOrder(razorpay_order_id: string, amount: number) {
    this.globalUtilityService.setDataOnLocalStorage(
      'rzp_order',
      JSON.stringify({
        razorpay_order_id: razorpay_order_id,
        amount: amount,
      }),
      true
    );
    setTimeout(() => {
      this.globalUtilityService.removeDataFromLocalStorage('rzp_order');
    }, 50000);
  }

  getCartSummary(payment_mode?: string): Observable<any> {
    if (this.globalUtilityService.isUserLoggedIn()) {
      return this.http
        .get(
          `${environment.BASE_URL}${GeneralApiEndpoints.GET_CART_SUMMARY}`,
          { payment_mode: payment_mode ? payment_mode : 'P' },
          true
        )
        .pipe(
          tap((response: APIResponse) => {
            this.sharedService.setCartSummary(response.data);
          }),
          catchError((error: any) => {
            throw new Error(error);
          })
        );
    } else {
      let cartItems =
        this.globalUtilityService.getDataFromLocalStorage('_cartItems');

      if (!cartItems) {
        cartItems = [];
      } else {
        cartItems = JSON.parse(cartItems);
      }

      if (cartItems.length === 0) {
        return of({});
      }

      return this.http
        .post(
          `${environment.BASE_URL}${GeneralApiEndpoints.GET_CART_SUMMARY}`,
          { cartItems, payment_mode },
          true
        )
        .pipe(
          tap((response: APIResponse) => {
            this.sharedService.setCartSummary(response.data);
          }),
          catchError((error: any) => {
            throw new Error(error);
          })
        );
    }
  }

  checkout(address_id: number, payment_mode: string): Observable<any> {
    return this.http
      .post(
        `${environment.BASE_URL}${GeneralApiEndpoints.CREATE_ORDER}`,
        { address_id, payment_mode },
        true
      )
      .pipe(
        catchError((error: any) => {
          throw new Error(error);
        })
      );
  }

  createOrder(
    order_id: number,
    razorpay_order_id: string,
    razorpay_payment_id: string,
    razorpay_signature: string,
    user_id: number | undefined,
    ...others: any[]
  ): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}${GeneralApiEndpoints.PLACE_ORDER}`,
      {
        razorpay_order_id,
        razorpay_payment_id,
        razorpay_signature,
        order_id,
        user_id,
        ...others,
      }
    );
  }

  cancelOrder(order_id: number, razorpay_order_id: string): Observable<any> {
    return this.http.get(
      `${environment.BASE_URL}${GeneralApiEndpoints.CANCEL_ORDER}`,
      { order_id, razorpay_order_id },
      true
    );
  }

  checkoutUserFlow(data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}${GeneralApiEndpoints.CHECKOUT_USER_FLOW}`,
        data
      )
      .pipe(
        catchError((error: any) => {
          throw new Error(error);
        })
      );
  }

  checkoutUserVerify(data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}${GeneralApiEndpoints.CHECKOUT_USER_VERIFY}`,
        data
      )
      .pipe(
        catchError((error: any) => {
          throw new Error(error);
        })
      );
  }
}
